import { render, staticRenderFns } from "./WalletReports.vue?vue&type=template&id=2061a6f2&scoped=true"
import script from "./WalletReports.vue?vue&type=script&lang=js"
export * from "./WalletReports.vue?vue&type=script&lang=js"
import style0 from "./WalletReports.vue?vue&type=style&index=0&id=2061a6f2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2061a6f2",
  null
  
)

export default component.exports